export enum LoadingState {
    Initialized = 'Initialized',
    Empty = 'Empty',
    Loading = 'Loading',
    Finished = 'Finished',
    Failed = 'Failed',
}
